import { MouseEvent } from 'react';

import DateSlotProps from './type';
import Typography from '../../Typography';
import { TucarTheme } from '../../theme';
import { getWeekDayIndex, compareTwoDates } from '../utils';
import { DateSlotStyled, SelectedDateSlotStyled } from './styled';

const DateSlot = ({ ...props }: DateSlotProps) => {
  const { disabled, multipleMode, label, onClick, style, selected, value, ...rest } = props;
  const isToday = value ? compareTwoDates(value, new Date(), 'equal') : false;

  const isSideLimit = () => {
    if (value && getWeekDayIndex(value) === 0) return 'left';
    if (value && getWeekDayIndex(value) === 6) return 'right';
    return undefined;
  };

  const handleClick = (event: MouseEvent<HTMLDivElement>) => {
    if (disabled) return;
    onClick(event);
  };

  const getSlotColor = () => {
    if (disabled) return TucarTheme.colors.gray600;
    if (isToday && !selected) return TucarTheme.colors.gray100;
    if (selected) return TucarTheme.colors.blue500;
    return TucarTheme.colors.gray800;
  };

  const renderLabel = () => (
    <Typography
      color={getSlotColor()}
      weight={selected ? 'bold' : 'medium'}
      align="center"
      style={{ fontSize: '14px', lineHeight: '120%' }}
    >
      {label}
    </Typography>
  );

  return (
    <DateSlotStyled
      multipleMode={multipleMode}
      disabled={disabled}
      onClick={handleClick}
      selected={selected}
      style={style}
      isSideLimit={isSideLimit()}
      {...{
        ...(multipleMode ? { 'data-multiple-mode': true } : {}),
        ...(disabled ? { 'data-disabled': true } : {}),
        ...(selected ? { 'data-selected': true } : {}),
        ...(isToday ? { 'data-is-today': true } : {}),
      }}
      {...rest}
    >
      {selected || isToday ? (
        <SelectedDateSlotStyled selected={selected} isToday={isToday}>
          {renderLabel()}
        </SelectedDateSlotStyled>
      ) : (
        renderLabel()
      )}
    </DateSlotStyled>
  );
};

export default DateSlot;
